<router-outlet></router-outlet>
<txp-toast-messages></txp-toast-messages>
@if (showSanta$ | async) {
  <img
    style="position: fixed; bottom: -15px; right: 100px; z-index: 999999"
    src="../../../assets/images/connect-christmas/santa-1.gif"
    [@enterAnimation]
  />
}
